(function(){
  function init(){
    var wrap=document.querySelector('.rx-shop-main');
    if(!wrap)return;
    var grid=wrap.querySelector('.rx-grid--products');
    if(!grid)return;
    var btn=wrap.querySelector('.rx-btn--ghost[href]');
    if(!btn||btn.dataset.rxLm)return;
    btn.dataset.rxLm='1';
    var label=btn.textContent;

    btn.addEventListener('click',function(e){
      e.preventDefault();
      var url=btn.getAttribute('href');
      if(!url||btn.dataset.busy)return;
      btn.dataset.busy='1';
      btn.textContent='Se încarcă…';
      fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){if(!r.ok)throw 0;return r.text()})
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var newGrid=doc.querySelector('.rx-grid--products');
          var newBtn=doc.querySelector('.rx-shop-main .rx-btn--ghost[href]');
          if(newGrid){
            var cards=newGrid.querySelectorAll('.rx-card');
            cards.forEach(function(c){
              c.style.opacity='0';
              c.style.transform='translateY(10px)';
              grid.appendChild(c);
              requestAnimationFrame(function(){
                c.style.transition='opacity .4s var(--ease),transform .4s var(--ease)';
                c.style.opacity='';c.style.transform='';
              });
            });
          }
          if(newBtn){
            btn.setAttribute('href',newBtn.getAttribute('href'));
            btn.textContent=label;
            btn.dataset.busy='';
          }else{
            btn.parentNode.removeChild(btn);
          }
          if(window.rxBindAtc)window.rxBindAtc();
          else document.dispatchEvent(new CustomEvent('rx:products-added'));
        })
        .catch(function(){window.location.href=url});
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();